var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.587,
    height: 38.247,
    viewBox: "0 0 34.587 38.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.683,
    cy: 4.683,
    r: 4.683,
    transform: "translate(11.79 13.62)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.856)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.438,
    cy: 3.438,
    r: 3.438
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.463 12.922V7.44"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.888)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.438,
    cy: 3.438,
    r: 3.438,
    transform: "translate(0 5.483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.463 0v4.699"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.586)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.438,
    cy: 3.438,
    r: 3.438
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.517 8.209L6.658 5.526"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.468 13.153)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.438,
    cy: 3.438,
    r: 3.438,
    transform: "translate(5.243 1.046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l4.922 2.718"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.07 7.586)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.438,
    cy: 3.438,
    r: 3.438,
    transform: "translate(4.641)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.209l4.859-2.683"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.739)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.438,
    cy: 3.438,
    r: 3.438,
    transform: "translate(0 1.046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.119 0L7.197 2.718"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.d7224d2e697c78416072eac26ca01ee0.svg";
export { ForwardRef as ReactComponent };